
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { splitIcon } from '../utils/Utilities';

import './Item.css';

//--- revisamos en el path si la pagina es el mismo link que esta activo
const isActiveItemJim = ({ link,  history }) => {
  
  const pathname = window.location.pathname;
  const active = pathname === link? true:false;
    
  return active;  //true o false
  
};

//===================================================================
const Item = ({ id, icon = 'fa fa-circle-o', text, labels, color, history, 
                children, activeOn, to, highlighted = false,
                handleToggle,
}) => {
  const localTo = to;

  const active = isActiveItemJim({ link: localTo, history });
  //const [activeChild1,setActiveChild1 ] = useState(false);

  /*console.log("labels:");
  console.log(labels);*/
  console.log(text);
  
  let localLabels='';
  if (labels) {
    if (Array.isArray(labels)) {
      localLabels = labels;
    } else {
      localLabels = [labels];
    }
  } else {
    localLabels = [];
  }
 
  //-----------
  const toggle = () =>{
    //setActiveChild1(!activeChild1);
    if(id!==undefined){
      if(activeChild){
        handleToggle(null);  //para que no expanda ninguno
      }else{
        handleToggle(id);  //solo expande el que tiene el id
      }
      
    }
  }
  //---------------------------------------------------------------
  /* es el cuadrado con numero que viene alado del texto de color primary o secondary */
  const mappedLabels = localLabels.map((p, index) => (
      <span key={ index } className={`label label-${p.type} pull-right`}>{p.text}</span>
  ));
  //----------------------------------------------------------------
  //const localColor = color ? TypeMappings.byColor[color].colorCode : '#d2d6de';
  let localColor = color? color: '#d2d6de';
  //const localIcon = splitIcon(icon);
  const localIcon = icon; //cadena fa fa-home

  const hasChildren = !!(children);
  const hasLabels = Array.isArray(localLabels);
  let localChildren=[];

  let activeChild = false; //original false
  if (hasChildren) {
    activeChild = activeOn; //viene desde afuera
  }
  /*if (hasChildren) {
    console.log("hasChildren:" + JSON.stringify(hasChildren));
    if (!Array.isArray(children)) {
      localChildren = [children];
    } else {
      localChildren = children;
    }
    localChildren = localChildren.filter(p => p && p instanceof Component).map(
      (p) => React.cloneElement(p, { key: p.props.to })
    );
    //--activechild es el que maneja si se despelega o no el submenu
    console.log(children);
    activeChild = !!(localChildren.find((p) => isActiveItemJim({
        history,
        link: p.props.to || p.props.link,
        ...p.props,
      })));
  }*/
    if (!hasChildren) {
      localColor='inherit'; //para que sea color heredado
    }
    let actualComponent = (
    <>
      {/*<i className="fa  fa-tachometer"></i>*/}
      
      <i className={`fa ${localIcon==''? "" : localIcon}`}  style={{color: localColor }}></i>
      {' '}
      <span>{text}</span>
      

      {/*si tiene hijos */}
      {(hasChildren || hasLabels) && (
        <span className="pull-right-container" style={{ display: "flex" }}>
          {/*hasChildren && <FontAwesomeIcon className="pull-right" icon="angle-left" />*/}
          {hasLabels && mappedLabels}
          {hasChildren && <i className="fa fa-angle-left"></i>}
        </span>
      )}

    </>
  );
  //---si existe una ruta 
  if (localTo) {
    actualComponent = (
      <Link to={localTo}>
        {actualComponent}
      </Link>
    );
  } else {
    actualComponent = (
      // eslint-disable-next-line no-script-url, jsx-a11y/anchor-is-valid
      <a href="#" onClick={toggle}  > {/* onClick={ toggle }*/}
        {actualComponent}
      </a>
    );
  }

  //---conjunto de clases
  const liClasses = [
    (active) ? 'active' : null,
    hasChildren ? 'treeview' : null,
    activeChild ? 'menu-open' : null,
    highlighted ? 'highlighted' : undefined,
  ].filter((p) => p).join(' ');

  //========================================= RENDER =========================
  return (
    <li className={liClasses} id={id} >
      {actualComponent}
      {hasChildren && (
        <ul className="treeview-menu " style={{ display: activeChild ? 'block' : 'none' }}>
          {children}
        </ul>
      )}
    </li>
  );
};

/*Item.defaultProps = {
  id: undefined,
  children: undefined,
  icon: 'far-circle',
  labels: undefined,
  color: undefined,
  activeOn: undefined,
  to: undefined,
  highlighted: false,
};
*/
export default Item;
